import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {BreadcrumbModule} from 'src/app/components/breadcrumb/breadcrumb.module';
import {CreateTenantRoutingModule} from './create-tenant-routing.module';
import {CreateTenantComponent} from './create-tenant.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {IconsModule} from 'src/app/icons/icons.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { ErrorModule } from 'src/app/components/error/error.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DatepickerModule } from 'src/app/components/datepicker/datepicker.module';
@NgModule({
  declarations: [
    CreateTenantComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BreadcrumbModule,
    CreateTenantRoutingModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    MatDividerModule,
    BrowserAnimationsModule,
    IconsModule,
    MatProgressBarModule,
    MatSelectModule,
    ErrorModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    SatPopoverModule,
    MatChipsModule,
    MatDatepickerModule,
    DatepickerModule
  ],
  exports: [
    CreateTenantComponent
  ]
})
export class CreateTenantModule {
}
